import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createLogger } from 'redux-logger';
import { reducer as reduxFormReducer } from 'redux-form';

import { history } from '../app/history';
import {
  sidebarReducer,
  themeReducer,
  appsReducer,
  userReducer,
  reportingReducer,
  mediaReducer
} from '../redux/reducers';
//import rootSaga from '../redux/sagas'
import userRootSaga from '../redux/sagas/UserSaga';
import appsRootSaga from '../redux/sagas/AppsSaga';
import reportsRootSaga from '../redux/sagas/ReportsSaga';
import mediaRootSaga from '../redux/sagas/MediaSaga';

// import configureFakeBackend from '../mocks/fakeBackend'
// configureFakeBackend();

const loggerMiddleware = createLogger();
const sagaMiddleware = createSagaMiddleware();

const appReducer = combineReducers({
  form: reduxFormReducer, // mounted under "formFields",
  theme: themeReducer,
  sidebar: sidebarReducer,
  authentication: userReducer,
  apps: appsReducer,
  reports: reportingReducer,
  media: mediaReducer
});

const rootReducer = (state, action) =>
  appReducer(
    action.type === 'LOGOUT_SUCCEEDED'
      ? {
          ...appReducer({}, {}),
          router: (state && state.router) || {}
        }
      : state,
    action
  );

/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  connectRouter(history)(rootReducer),
  composeEnhancers(
    applyMiddleware(routerMiddleware(history), sagaMiddleware, loggerMiddleware)
  )
);

/* eslint-enable */

sagaMiddleware.run(userRootSaga);
sagaMiddleware.run(appsRootSaga);
sagaMiddleware.run(reportsRootSaga);
sagaMiddleware.run(mediaRootSaga);
export default store;



// WEBPACK FOOTER //
// ./src/app/store.js